module.exports = __webpack_public_path__ + "img/logo_long.ce132167.png";